// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3TuIZ","info":"PatientInfo_info__3bMMf"};